import { t } from '../i18n';

/** Trigger a browser download; fall back to the clipboard if blocked. */
export async function download(filename: string, text: string, mime: string): Promise<string> {
  try {
    const blob = new Blob([text], { type: `${mime};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 1000);
    return t('lib.downloaded', { filename });
  } catch {
    await copyText(text);
    return t('lib.downloadFailedCopied');
  }
}

export async function copyText(text: string): Promise<string> {
  try {
    await navigator.clipboard.writeText(text);
    return t('lib.copiedClipboard');
  } catch {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok ? t('lib.copiedClipboard') : t('lib.copyFailed');
  }
}

/** Read a user-picked file as text. */
export function pickFile(accept: string): Promise<{ name: string; text: string } | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.style.display = 'none';
    document.body.appendChild(input);
    input.addEventListener('change', () => {
      const file = input.files?.[0];
      input.remove();
      if (!file) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => resolve({ name: file.name, text: String(reader.result ?? '') });
      reader.onerror = () => resolve(null);
      reader.readAsText(file);
    });
    input.click();
  });
}
